export const OPTIN_NAME = 'Nav IA Update Spotlight 2025';